import { ArrowRight, Sparkles } from "lucide-react";
import { HELLOASSO_URL } from "@/lib/data";

export const Hero = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="hero" className="relative overflow-hidden pt-16 pb-28 md:pt-24 md:pb-40" data-testid="hero-section">
      {/* Decorative pastel blobs */}
      <div className="absolute -top-32 -left-24 w-[460px] h-[460px] rounded-full bg-[#FFD6C9] blur-3xl opacity-70 blob-animate pointer-events-none" />
      <div className="absolute -bottom-40 -right-10 w-[560px] h-[560px] rounded-full bg-[#C4F4E4] blur-3xl opacity-60 blob-animate pointer-events-none" style={{ animationDelay: "3s" }} />
      <div className="absolute top-32 right-1/4 w-[300px] h-[300px] rounded-full bg-[#E6D7FF] blur-3xl opacity-60 blob-animate pointer-events-none" style={{ animationDelay: "6s" }} />
      <div className="absolute bottom-32 left-1/3 w-[220px] h-[220px] rounded-full bg-[#FFF3B0] blur-3xl opacity-50 blob-animate pointer-events-none" style={{ animationDelay: "4.5s" }} />

      {/* Decorative logo in top-right corner */}
      <img
        src="/images/logo.png"
        alt=""
        aria-hidden="true"
        className="hidden md:block absolute top-10 right-10 w-32 lg:w-40 opacity-70 rotate-[-8deg] pointer-events-none rounded-2xl"
      />

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 bg-white border border-black/80 rounded-full px-4 py-2 shadow-brutal-sm mb-10">
          <Sparkles size={14} />
          <span className="font-sans text-xs font-bold tracking-widest uppercase">
            Pays Basque · Saint-Jean-de-Luz
          </span>
        </div>

        <h1 className="font-display text-7xl sm:text-8xl md:text-9xl lg:text-[10rem] leading-[0.86] uppercase">
          Corps
          <span className="inline-block mx-2 md:mx-3 text-[#FF6B6B]">·</span>
          <br />
          Scène
          <span className="inline-block mx-2 md:mx-3 text-[#8B5CF6]">·</span>
          <br />
          Coaching
        </h1>

        <p className="mt-10 max-w-xl mx-auto text-lg md:text-2xl text-[#1a1a1a] leading-relaxed font-medium">
          Ce n'est pas une école, c'est une expérience.
          <br />
          <span className="italic text-[#3a3a3a]">Bouger, oser, créer.</span>
        </p>

        <div className="mt-12 flex flex-wrap gap-4 justify-center">
          <button
            onClick={() => scrollTo("activites")}
            data-testid="hero-cta-activities"
            className="group bg-[#0A0A0A] text-white rounded-full px-8 py-4 font-sans font-bold text-base inline-flex items-center gap-2 hover:-translate-y-1 transition-transform"
          >
            Découvrir les activités
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </button>
          <a
            href={HELLOASSO_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-cta-reserver"
            className="bg-[#FFF3B0] text-[#0A0A0A] border border-black rounded-full px-8 py-4 font-sans font-bold text-base inline-flex items-center gap-2 shadow-brutal-sm hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-none transition-all"
          >
            Réserver ma place
          </a>
        </div>

        <div className="mt-16 inline-flex items-center gap-3 bg-white/80 backdrop-blur-sm border-2 border-black rounded-full px-5 py-3 shadow-brutal-sm rotate-[-2deg]">
          <span className="font-display text-xl md:text-2xl tracking-wide">Bouger · Oser · Créer</span>
        </div>
      </div>
    </section>
  );
};
